import type { Extension } from 'services/extensions/types'
import actions from './actions'

export interface ExtensionsState {
  /** The region-wide catalog, with `price` and `installed` stamped on by the saga. */
  extensionsAllList: Extension[]
  /** The app's installed extensions, with `price` stamped on. Source of `adminURL`. */
  extensionsInstalledList: Extension[]
  /** Feature slugs an upgrade intent has already been sent for, so we don't nag twice. */
  sentManualIntentExtensionIds: string[]
  areExtensionsLoading: boolean
}

const initialState: ExtensionsState = {
  extensionsAllList: [],
  extensionsInstalledList: [],
  sentManualIntentExtensionIds: [],
  areExtensionsLoading: false,
}

interface SetStateAction {
  type: string
  payload?: Partial<ExtensionsState>
}

export default function extensionsReducer(
  state: ExtensionsState = initialState,
  action: SetStateAction = { type: '' },
): ExtensionsState {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
